module.exports = __webpack_public_path__ + "static/whitney-cummings-42693a911f60867b7e754af02cea4d5d.jpg";